import PrivacyPolicyComp from '../../app/features/PrivacyPolicy';
const PrivacyPolicy = () => {

    return (
        <div style={{ minHeight: "60vh" }}>
            <PrivacyPolicyComp />
        </div>
    )
}
export default PrivacyPolicy